import { TvAiLogItem } from "types/TvPosterTypes";

const MONTHS = [
  "jan",
  "feb",
  "mar",
  "apr",
  "mai",
  "jun",
  "jul",
  "aug",
  "sep",
  "okt",
  "nov",
  "des",
];

const pad = (n: number) => String(n).padStart(2, "0");

/**
 * «16. okt kl. 12:41» (lokal tid). Året tas med når det ikke er i år.
 * Ugyldige verdier returneres uendret.
 */
export const formatLogTime = (
  iso: string | null | undefined,
  now = new Date(),
) => {
  if (!iso) return "–";
  const date = new Date(iso);
  if (isNaN(date.getTime())) return iso;
  const year =
    date.getFullYear() !== now.getFullYear() ? ` ${date.getFullYear()}` : "";
  return `${date.getDate()}. ${MONTHS[date.getMonth()]}${year} kl. ${pad(
    date.getHours(),
  )}:${pad(date.getMinutes())}`;
};

/** «1 234» med norsk tusenskille. */
export const formatCount = (n: number | null | undefined) =>
  typeof n === "number" ? n.toLocaleString("nb-NO") : "–";

/** «modell · 1 234 tokens · 3,2 s», uten deler som mangler. */
export const metaLine = (
  item: Pick<
    TvAiLogItem,
    "model" | "inputTokens" | "outputTokens" | "durationMs"
  >,
) => {
  const parts: string[] = [];
  if (item.model) parts.push(item.model);
  if (item.inputTokens != null || item.outputTokens != null) {
    const tokens = (item.inputTokens ?? 0) + (item.outputTokens ?? 0);
    parts.push(`${formatCount(tokens)} tokens`);
  }
  if (item.durationMs != null) {
    parts.push(
      `${(item.durationMs / 1000).toLocaleString("nb-NO", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      })} s`,
    );
  }
  return parts.join(" · ");
};

/** URL til listen. `page` er 1-basert her, 0-basert i API-et. */
export const aiLogUrl = (page: number, size: number, orgNr?: string) =>
  `/api/v1/admin/tv-posters/ai-log?page=${Math.max(0, page - 1)}&size=${size}${
    orgNr ? `&orgNr=${encodeURIComponent(orgNr)}` : ""
  }`;

export const previewUrl = (id: number, index: number) =>
  `/api/v1/admin/tv-posters/ai-log/${id}/preview/${index}`;
